import React from "react";
import "./style.css";
import PrimeryButton from "../../ControlledComponents/PrimeryButton/PrimeryButton";
import playBtn from '../../Assets/icons/play-button (1).png'
import PlayIcon from "../../GlobalComponents/Play-button-1";
import Button4 from "../../GlobalComponents/button3";
import { AiFillFire } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import about_2 from "../../Assets/about/about_2.jpg"
import { useTranslation } from "react-i18next";

export default function ServiceCard2() {
    const { t ,i18n} = useTranslation();
    const navigate = useNavigate()
    return(
        <div className="service-name-2">
            <div className="content_section">
                <p className="content_section_p">
                    <span style={{fontWeight:"bold"}}>{t("about.bigpara")}</span> <br/>
{t("about.smallpara")}

                </p>
                <Button4 
                    text_1={t("about.button")}
                    text_2={t("about.button")} 
                    iconComponent={AiFillFire} 
                    width={"265px"}   
                    navigateClick={() => {
                        navigate("/contact-us")
                    }} 
                    height={"55px"}
                />
            </div>
            <div className="service-poster-2">
                {/* <img src={playBtn} alt="play" className="play-button" /> */}
                <div className="play-button">
                <PlayIcon height={"60px"} width={"60px"} />
                </div>
                
            </div>
        </div>
    )
}